<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap justify-space-around>
      <v-flex xs12 sm12 md6 lg4 xl4>
        <v-card>
          <v-toolbar color="pink" dark>
            <v-toolbar-title class="text-xs-center">مسابقات پیشین</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-avatar color="white">
              <v-icon color="pink">dashboard</v-icon>
            </v-avatar>
          </v-toolbar>

          <v-list subheader>
            <v-subheader>گروه مسابقه دهندگان</v-subheader>
            <v-list-tile v-for="(item,index) in previousRacers" :key="index" avatar>
              <v-list-tile-avatar>
                <img :src="item.avatar" />
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title class="txt-right" v-html="item.name"></v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-content>
                <v-list-tile-title class="txt-right" v-html="item.city"></v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-icon :color="item.active ? 'pink' : 'grey'">archive</v-icon>
              </v-list-tile-action>
            </v-list-tile>

            <v-divider></v-divider>

            <div class="text-xs-center mt-2">
              <v-btn
                :loading="loading3"
                :disabled="loading3"
                color="#e91e63"
                class="white--text"
                @click="more"
                large
                round
              >مسابقات بیشتر ...</v-btn>
            </div>
          </v-list>
        </v-card>
      </v-flex>

      <v-flex xs12 sm12 md6 lg4 xl4>
        <v-card>
          <v-toolbar color="green" dark>
            <v-toolbar-title class="text-xs-center">مسابقات در حال برگزاری</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-avatar color="white">
              <v-icon color="green">dashboard</v-icon>
            </v-avatar>
          </v-toolbar>

          <v-list subheader>
            <v-subheader>گروه مسابقه دهندگان</v-subheader>
            <v-list-tile v-for="(item,index) in activeRaces" :key="index" avatar>
              <v-list-tile-avatar>
                <img :src="item.avatar" />
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title class="txt-right" v-html="item.name"></v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-content>
                <v-list-tile-title class="txt-right" v-html="item.city"></v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-icon :color="item.active ? 'green' : 'grey'">archive</v-icon>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider></v-divider>
            <div class="text-xs-center mt-2">
              <v-btn
                :loading="loading3"
                :disabled="loading3"
                color="#4caf50"
                class="white--text"
                @click="loader = 'morea'"
                large
                round
              >مسابقات بیشتر ...</v-btn>
            </div>
          </v-list>
        </v-card>
      </v-flex>

      <v-flex xs12 sm12 md6 lg4 xl4>
        <v-card>
          <v-toolbar color="blue darken-1 " dark>
            <v-toolbar-title class="text-xs-center">مسابقات آینده</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-avatar color="white">
              <v-icon color="blue darken-1">dashboard</v-icon>
            </v-avatar>
          </v-toolbar>

          <v-list subheader>
            <v-subheader>گروه مسابقه دهندگان</v-subheader>

            <v-list-tile v-for="(item,index) in futureRaces" :key="index" avatar>
              <v-list-tile-avatar>
                <img :src="item.avatar" />
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title class="txt-right" v-html="item.name"></v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-content>
                <v-list-tile-title class="txt-right" v-html="item.city"></v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-icon :color="item.active ? 'blue darken-1' : 'grey'">archive</v-icon>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider></v-divider>

            <div class="text-xs-center mt-2">
              <v-btn
                :loading="loading3"
                :disabled="loading3"
                color="#1e88e5"
                class="white--text"
                @click="loader = 'moren'"
                large
                round
              >مسابقات بیشتر ...</v-btn>
            </div>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import RaceServices from "@/services/RaceServices";
export default {
  data() {
    return {
      previousRacers: [],
      activeRaces: [],
      futureRaces: [],
      countp: 5,
      offsetp: 5,
      countr: 5,
      offsetr: 5,
      countn: 5,
      offsetn: 5,
    };
  },
  async mounted() {
    this.previousRacers = (await RaceServices.finIndex(
      this.countp,
      this.offsetp
    )).data;
    this.activeRaces = (await RaceServices.runIndex(
      this.countr,
      this.offsetr
    )).data;
    this.futureRaces = (await RaceServices.nextIndex(
      this.countn,
      this.offsetn
    )).data;
  },
  methods: {
    async more() {
      this.countp += 5;
      this.offsetp += 5;
      this.previousRacer = (await RaceServices.finIndex(
        this.countp,
        this.offsetp
      )).data;
    }
  },
  computed: {
    previousRacers: function() {
      return this.previousRacer;
    }
  }
};
</script>

<style scoped>
</style>
